const gql = String.raw;
  
export const Document = gql`
query DocumentBySlugQuery($slug: ID!) {
  documentBySlug(slug: $slug) {
    
      id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    
    type { id name slug __typename }
    content { id text }
    description { id text }
    folder { id name slug }
    owner {
      id name slug path __typename
      openGraph { image { thumbnails { bubble { url url2x } } } }
    }
    files {
      id name slug
      file { id url extension }
    }
    openGraph {
      title
      description { plain }
      image { url url2x thumbnails { card { url url2x } } }
    }
  }
}

`;
